import { useEffect } from "react";
import {
  UMAMI_DOMAINS,
  UMAMI_SCRIPT_URL,
  UMAMI_WEBSITE_ID,
} from "../config/env";

export default function UmamiAnalytics() {
  useEffect(() => {
    if (!UMAMI_WEBSITE_ID || !UMAMI_SCRIPT_URL) {
      return undefined;
    }

    if (document.querySelector(`script[src="${UMAMI_SCRIPT_URL}"]`)) {
      return undefined;
    }

    const scriptElement = document.createElement("script");
    scriptElement.defer = true;
    scriptElement.src = UMAMI_SCRIPT_URL;
    scriptElement.dataset.websiteId = UMAMI_WEBSITE_ID;
    // Tracking result URLs can carry captcha payloads (altcha_token) before the
    // page strips them; never send query strings to analytics.
    scriptElement.dataset.excludeSearch = "true";

    if (UMAMI_DOMAINS) {
      scriptElement.dataset.domains = UMAMI_DOMAINS;
    }

    document.head.appendChild(scriptElement);

    return undefined;
  }, []);

  return null;
}
